import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GridModule } from '@progress/kendo-angular-grid';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { CurrencyTotalModule } from '@app/shared/components/ui';

import { ExpenseGridComponent } from '../../..';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [ExpenseGridComponent],
  imports: [
    CommonModule,
    FlexLayoutModule,
    GridModule,

    CurrencyTotalModule,
    TranslateModule
  ],
  exports: [ExpenseGridComponent, TranslateModule]
})
export class ExpenseGridModule {}
